export default __webpack_public_path__ + "static/media/valparaiso.63dff773.svg";